import { useContext, useState } from "react";
import "./App.css";
import AllRoutes from "./routes/AllRoutes";
import { AppContext } from "./context/AppContext";
import TelegramModal from "./components/TelegramModal";
import InstagramModal from "./components/InstagramModal";
import WhatsappModal from "./components/WhatsappModal";

function App() {
  const { isDark, userEmail, isInsta } = useContext(AppContext);

  return (
    <div
      style={
        isDark
          ? { background: "#0F1624", minHeight: "100vh", color: "white" }
          : { background: "#EDF2F8", minHeight: "100vh", color: "black" }
      }
    >
      {/* <Navbar /> */}
      {userEmail?.length != 0 && (isInsta ? <InstagramModal /> : <WhatsappModal />)}
      <AllRoutes />
    </div>
  );
}

export default App;
